import React from 'react';
import { ProCard } from '@bedrock/eed-react';
import { useUpdateEffect } from 'ahooks';
import { PrePaymentFormModel } from '../../FormModel';
import { Alert } from '@bedrock/components';
import classNames from 'classnames/bind';
import usePrepayment from '@mpc/common/src/model/Prepayment';
import type { DetailProps } from '../../Drawer/DetailContainer';

import styles from './index.less';

const cx = classNames.bind(styles);

const PrePaymentDetail = ({ formData, setFormData, form }: DetailProps) => {
  const { detail } = usePrepayment();
  
  // 当发票国家/地区发生变化时 是否海外发票发生变化时，清空发票列表
  useUpdateEffect(() => {
    if (detail?.permission_info?.can_upload_invoice) {
      form.setFieldValue(['invoice_info', 'invoice_list'], [])
      setFormData()
    }
  }, [formData?.invoice_info?.invoice_belong_area, formData?.invoice_info?.is_oversea_invoice, detail])

  return (
    <>
      <ProCard title="预付信息" expandable>
        <div className={cx('prepayment-detail__container')}>
          <div className={cx('prepayment-detail__content-item')}>
            <PrePaymentFormModel
              renderType={'descriptions'}
              renderData={{ detailData: detail, formData }}
              globalItemProps={{
                view: true
              }}
              itemCols={[
                {
                  formItemKey: 'base_info.prepayment_no',
                  view: true,
                },
                {
                  formItemKey: 'base_info.demand_id',
                  view: true,
                },
                'base_info.$prepayment_amount',
                'contract_info.contract_no',
                'invoice_info.invoice_method',
                'base_info.invoice_entity',
              ]}
            />
          </div>
        </div>
      </ProCard>
      {/* 发票信息 */}
      <ProCard title="发票信息" expandable>
        {
          detail?.permission_info?.can_upload_invoice &&
          <Alert
            message='请确保提供与支付款项等额发票，超额开具部分，网易将不予受理退回款申请，亦不可用于抵扣合作尾款或其他合作款项。'
            type='warning'
            showIcon
            style={{ margin: `0 0 20px` }}
          />
        }
        <PrePaymentFormModel
          renderType={'descriptions'}
          renderData={{ detailData: detail, formData }}
          globalItemProps={{
            view: !detail?.permission_info?.can_upload_invoice,
          }}
          itemCols={[
            'invoice_info.invoice_belong_area',
            'invoice_info.is_oversea_invoice',
            {
              formItemKey: 'invoice_info.invoice_list',
              view: !detail?.permission_info?.can_upload_invoice,
            },
          ]}
        />
      </ProCard>
    </>
  );
};

export default PrePaymentDetail;
